export default {
  getDaysList()
  {
    let _days = [];
    for(var i = 1;i<32;i++)
    {
      _days.push(i);
    }
    return _days;
  },
  getMonthsList()
  {
    let _months = [];
    for(var i = 1;i<13;i++)
    {
      _months.push(i);
    }
    return _months;
  },
  getYearsList()
  {
    let _years = []
    const now = new Date();
    let _year0 = 1900;
    for(var i = _year0;i<now.getFullYear()+1;i++)
    {
      _years.push(i);
    }
    return _years;
  },
  removeSpecialChar(str){
      if(str == null || str == ''){
        return '';
    }
    return str.replace(/[^a-zA-Z0-9 ]/g, '')
  },
  isEmpty(obj) {
    if(obj)
    {
      return Object.keys(obj).length === 0 && obj.constructor === Object
    }
    else
    {
      return true;
    }
    
  },
  getcurrentdate() {
    const now = new Date();
    let datetime = now.toLocaleDateString();
    let time = now.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});
    let str = datetime + " " + time;
    return str;
  },
  getcurrentdateasnumber(){
    const now = new Date();
      let _year = now.getFullYear();
      let _month = now.getMonth()+1; //plus 1 because from 0 to 11
      let _day = now.getDate();
      let _hour = now.getHours();
      let _min = now.getMinutes();
      let _sec = now.getSeconds();
      let _monthStr = _month.toString();
      let _dayStr = _day.toString();
      let _hourStr = _hour.toString();
      let _minStr = _min.toString();
      let _secStr = _sec.toString();
      if(_month < 10)
      {
        _monthStr = '0'+_month.toString();
      }
      if(_day < 10)
      {
        _day = '0'+_day.toString();
      }
      if(_hour < 10)
      {
        _hourStr = '0'+_hour.toString();
      }
      if(_min < 10)
      {
        _minStr = '0'+_min.toString();
      }
      if(_sec < 10)
      {
        _secStr = '0'+_sec.toString();
      }
      let str = _year.toString()+_monthStr+_dayStr+_hourStr+_minStr+_secStr;
      return str;
  },
  displaydate(m, alt) {
    if (m.length < 1) {
      m = alt;
    }
    let res = m.split(" ");
    let datetime = res[0];
    let time = res[1];

    let now = new Date();
    //let offsetMs = now.getTimezoneOffset() * 60 * 1000;
    //let dateLocal = new Date(now.getTime() - offsetMs);
    let currentdate = now.toLocaleDateString();

    var yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
    let yesterdayoffsetMs = yesterday.getTimezoneOffset() * 60 * 1000;
    let yesterdaydateLocal = new Date(yesterday.getTime() - yesterdayoffsetMs);
    let yesterdate = yesterdaydateLocal.toLocaleDateString();

    if (datetime === currentdate) {
      datetime = "Today";
    }
    if (datetime === yesterdate) {
      datetime = "Yesterday";
    }

    let str = datetime + ", " + time;
    return str;
  },
  combinetext(a, b) {
    return a + b;
  },
  inWords(num) {
    var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];


    if ((num = num.toString()).length > 9) return 'overflow';
    let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return; var str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + ' ' : '';
    return str;
  },
  getDateOnlyAsString(d)
  {
    let _date = "";
    if(d){
      _date = d.getDate()+"/"+(d.getMonth()+1)+"/"+d.getFullYear();
    }
    return _date;
  },
  getDateOnlyAsString2(d)
  {
    let _date = "";
    if(d){
      const _d = new Date(d);
      _date = _d.getDate()+"/"+(_d.getMonth()+1)+"/"+_d.getFullYear();
    }
    return _date;
  },
  getDatetimeAsString()
  {
    let d = new Date();
    let _date = "";
    if(d){
      _date = d.getFullYear()+""+(d.getMonth()+1)+""+d.getDate()+""+d.getHours()+""+d.getMinutes()+""+d.getSeconds();
    }
    return _date;
  },
  consolelog(msg){
    console.log(msg);
  },
  getallquestions(pastreviews)
  {
    let qset = [];
    let headings = [];
    //let questions = [];
    if (pastreviews && pastreviews.length > 0) {
      for(let i=0;i<pastreviews.length;i++)
      {
        let s = pastreviews[i];
        
        if(s && s.postreview && s.postreview_shared)
        {
          s.postreview.forEach((pr) => {
            let _exist = false;
            headings.forEach(h=>{
              if(h.name === pr.name)
              {
                _exist = true;
              }
            });
            if(!_exist)
            {
              headings.push({
                name: pr.name,
                questions: []
              });
            }
          });
        }
        if(s && s.prereview && s.prereview_shared)
        {
          s.prereview.forEach((pr) => {
            let _exist = false;
            headings.forEach(h=>{
              if(h.name === pr.name)
              {
                _exist = true;
              }
            });
            if(!_exist)
            {
              headings.push({
                name: pr.name,
                questions: []
              });
            }
          });
        }
      }

      headings.forEach(h=>{
        
        pastreviews.forEach(r=>{
          
          if(typeof r !== 'undefined' && r.postreview && r.postreview_shared)
          {
            r.postreview.forEach((pr) => {
              if(h.name === pr.name)
              {
                pr.questions.forEach(q=>{
                  let _exist3 = false;
                  h.questions.forEach(q2=>{
                    if(q.name === q2.name)
                    {
                      _exist3 = true;
                    }
                  })
                  if(!_exist3)
                  {
                    h.questions.push(
                      {
                        name: q.name,
                        answers: []
                      }
                    );
                  }
                });
              }
            });
          }

          if(typeof r !== 'undefined' && r.prereview && r.prereview_shared)
          {
            r.prereview.forEach((pr) => {
              if(h.name === pr.name)
              {
                pr.questions.forEach(q=>{
                  let _exist2 = false;
                  h.questions.forEach(q2=>{
                    if(q.name === q2.name)
                    {
                      _exist2 = true;
                    }
                  })
                  if(!_exist2)
                  {
                    h.questions.push(
                      {
                        name: q.name,
                        answers: []
                      }
                    );
                  }
                });
              }
            });
          }

        });
      });
    }

    headings.forEach(h=>{
      h.questions.forEach(q=>{

        pastreviews.forEach(r=>{
          
          if(typeof r !== 'undefined' && r.postreview && r.postreview_shared)
          {
            r.postreview.forEach((pr) => {
              if(h.name === pr.name)
              {
                pr.questions.forEach(q2=>{
                  if(q.name === q2.name)
                  {
                     let _ans2 = "";
                     if(q2.type === "radiobutton")
                     {
                        q2.prevalues.forEach(a=>{
                          if(a.selected)
                          {
                            _ans2 = a.name;
                          }
                        });
                     }
                    
                     if(q2.type === "checkboxlist")
                     {
                        let _anslist2 = [];
                        q2.prevalues.forEach(a=>{
                          if(a.selected)
                          {
                            _anslist2.push(a.name);
                          }
                        });
                        if(_anslist2.length > 0)
                        {
                          _ans2 = _anslist2.join();
                        }
                     }

                     if(_ans2.length > 0)
                     {
                      let _answer2 = _ans2; // +" <strong>Postreview - "+this.getDateOnlyAsString2(r.reviewdate)+"</strong>";
                      
                      q.answers.push({
                        reviewdate:r.reviewdate,
                        type:"postreview",
                        name: this.getDateOnlyAsString2(r.reviewdate) + " - Post",
                        answer:_answer2
                      });
                     }

                     
                  }
                });
              }
            });
          }

          if(typeof r !== 'undefined' && r.prereview && r.prereview_shared)
          {
            r.prereview.forEach((pr) => {
              if(h.name === pr.name)
              {
                pr.questions.forEach(q2=>{
                  if(q.name === q2.name)
                  {
                     let _ans = "";
                     if(q2.type === "radiobutton")
                     {
                        q2.prevalues.forEach(a=>{
                          if(a.selected)
                          {
                            _ans = a.name;
                          }
                        });
                     }
                    
                     if(q2.type === "checkboxlist")
                     {
                        let _anslist = [];
                        q2.prevalues.forEach(a=>{
                          if(a.selected)
                          {
                            _anslist.push(a.name);
                          }
                        });
                        if(_anslist.length > 0)
                        {
                          _ans = _anslist.join();
                        }
                     }
                     if(_ans.length > 0)
                     {
                      let _answer1 = _ans ; //+" <strong>Preview - "+this.getDateOnlyAsString2(r.reviewdate)+"</strong>";
                      q.answers.push({
                        reviewdate:r.reviewdate,
                        type:"prereview",
                        name: this.getDateOnlyAsString2(r.reviewdate) + " - Pre",
                        answer:_answer1
                      });
                     }
                     
                  }
                });
              }
            });
          }

        });

      });
    });
    qset.push(headings);
    return qset;
  }
}

